import { useQuery } from "@tanstack/react-query";
import axios from "axios";

import { __API_URL__ } from "../SERVER_URL";

const fetchVisitStatusSummary = async ({ patientId, trialId }) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${__API_URL__}/api/photos/get_visit_status_summary/`, {
    params: {
      patientId,
      trialId,
    },
    headers: {
      Authorization: `Token ${token}`,
    },
  });
  return response.data;
};

const useGetVisitStatusSummary = ({ patientId, trialId, enabled = true }) => {
  return useQuery({
    queryKey: ["visit-status-summary", patientId, trialId],
    queryFn: () => fetchVisitStatusSummary({ patientId, trialId }),
    enabled: enabled && Boolean(patientId) && Boolean(trialId),
  });
};

export default useGetVisitStatusSummary;
